<app-page-breadcrumb pageTitle="Plantillas de email"></app-page-breadcrumb>

<div class="space-y-4">
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <select [(ngModel)]="filterType" (ngModelChange)="load()"
      class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
      <option value="">Todos los tipos</option>
      @for (t of types; track t) { <option [ngValue]="t">{{ typeLabel(t) }}</option> }
    </select>

    <button type="button" *appHasPermission="'meetings:create'" (click)="crear()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Nueva plantilla
    </button>
  </div>

  @if (error) { <p class="text-sm text-error-600">{{ error }}</p> }

  @if (loading) {
    <div class="flex justify-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    </div>
  } @else if (items.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400 py-4">No hay plantillas registradas.</p>
  } @else {
    <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tipo</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Asunto</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          <!-- INC 81: las predeterminadas DEL SISTEMA van primero y en solo lectura. Son las
               que se envían mientras el negocio no marque una propia como predeterminada;
               antes no se veían y, sin default, salía una plantilla cualquiera del cliente. -->
          @for (sys of visibleSystemDefaults; track sys.templateType) {
            <tr class="bg-gray-50/60 dark:bg-white/[0.02]">
              <td class="px-4 py-3 text-sm text-gray-800 dark:text-white/90">
                <span class="font-medium">{{ sys.name }}</span>
                <span class="ml-2 text-xs px-2 py-0.5 rounded bg-blue-light-100 text-blue-light-700 dark:bg-blue-light-500/15 dark:text-blue-light-400">
                  Predeterminada del sistema
                </span>
                @if (usandoPlantillaDelSistema(sys.templateType)) {
                  <span class="ml-2 text-xs px-2 py-0.5 rounded bg-success-100 text-success-700"
                        title="No hay ninguna plantilla propia marcada como predeterminada para este tipo, así que se envía esta.">
                    en uso
                  </span>
                }
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                <span class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{{ typeLabel(sys.templateType) }}</span>
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300 max-w-md truncate">{{ sys.subject }}</td>
              <td class="px-4 py-3 text-sm">
                <span class="text-xs px-2 py-0.5 rounded bg-success-100 text-success-700">activa</span>
              </td>
              <td class="px-4 py-3 text-center text-xs text-gray-400 dark:text-gray-500"
                  title="La plantilla base del sistema no se puede editar ni eliminar: garantiza que siempre exista un correo que enviar.">
                No editable
              </td>
            </tr>
          }
          @for (item of items; track item.id) {
            <tr>
              <td class="px-4 py-3 text-sm text-gray-800 dark:text-white/90">
                <span class="font-medium">{{ item.name }}</span>
                <!-- INC 81: "predeterminada" es lo que decide qué se envía, así que la etiqueta
                     lo dice con todas las letras (antes ponía "default"). -->
                @if (item.isDefault) {
                  <span class="ml-2 text-xs px-2 py-0.5 rounded bg-brand-100 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
                        title="Esta es la plantilla que se envía para este tipo.">Predeterminada</span>
                }
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                <span class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{{ typeLabel(item.templateType) }}</span>
                <!-- INC 80: los tipos sin disparador se marcan; antes parecían operativos. -->
                @if (!seEnvia(item.templateType)) {
                  <span class="ml-2 text-xs px-2 py-0.5 rounded bg-warning-50 text-warning-700 dark:bg-warning-500/15 dark:text-warning-400"
                        [title]="usoDe(item.templateType)">sin envío automático</span>
                }
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300 max-w-md truncate">{{ item.subject }}</td>
              <td class="px-4 py-3 text-sm">
                @if (item.isActive) {
                  <span class="text-xs px-2 py-0.5 rounded bg-success-100 text-success-700">activa</span>
                } @else {
                  <span class="text-xs px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">inactiva</span>
                }
              </td>
              <td class="px-4 py-3 text-sm text-center">
                <div class="flex items-center justify-center gap-2">
                  <button *appHasPermission="'meetings:edit'" (click)="editar(item)"
                    class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">Editar</button>
                  <button *appHasPermission="'meetings:delete'" (click)="eliminar(item)"
                    class="text-xs px-2 py-1 rounded border border-error-300 text-error-600 hover:bg-error-50">Eliminar</button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
